import { useSearchParams } from 'react-router-dom';
import { ScanBarcode, Tag, Sparkles, type LucideIcon } from 'lucide-react';
import { ScoutPage } from './ScoutPage';
import { PriceAdvisorPage } from './PriceAdvisorPage';
import { AIAssistantPage } from './AIAssistantPage';

type Tool = 'scout' | 'price' | 'ai';

const TABS: { id: Tool; label: string; icon: LucideIcon }[] = [
  { id: 'scout', label: 'Scout', icon: ScanBarcode },
  { id: 'price', label: 'Price advisor', icon: Tag },
  { id: 'ai', label: 'AI assistant', icon: Sparkles },
];

export function ToolsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const active = (searchParams.get('tab') as Tool) ?? 'scout';

  function setTab(tab: Tool) {
    setSearchParams({ tab }, { replace: true });
  }

  return (
    <div className="flex flex-col gap-3.5">
      {/* Tab switcher */}
      <div className="flex gap-1 bg-white/[0.03] border border-white/[0.06] rounded-xl p-1">
        {TABS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-[12.5px] font-medium transition-colors ${
              active === id
                ? 'bg-primary-500/[0.15] text-primary-300'
                : 'text-white/40 hover:text-white/60'
            }`}
          >
            <Icon size={13} />
            <span className="hidden sm:inline">{label}</span>
            <span className="sm:hidden">{label.split(' ')[0]}</span>
          </button>
        ))}
      </div>

      {active === 'scout' && <ScoutPage />}
      {active === 'price' && <PriceAdvisorPage />}
      {active === 'ai' && <AIAssistantPage />}
    </div>
  );
}
